import React from 'react';
import { endOfMonth, format, isAfter, isBefore, isEqual, isPast, isToday, startOfDay, startOfMonth } from "date-fns";
import OverridesAssistanceButton from "./OverridesAssistanceButton";
import TimeslotsInput from "./TimeslotsInput";
import PropTypes from "prop-types";

const CalendarOverridesDay = (props) => {
    const day = props.day;
    const currentDate = props.currentDate;

    let dateIndex = format(day, 'yyyy-MM-dd');

    const getClasses = () => {
        let classes = [];

        if (!isToday(day) && isPast(day)) {
            classes.push('past-date');
        }

        if (!isEqual(day, startOfMonth(currentDate)) && (!isAfter(day, startOfMonth(startOfDay(currentDate))) || !isBefore(day, endOfMonth(currentDate)))) {
            classes.push('diff-month');
        } else {
            if (props.daySlots) {
                classes.push('has-overrides');
                if (!props.daySlots.length) {
                    classes.push('is-closed');
                }
            }
        }

        return classes;
    }

    const getDateOverrides = (date) => {
        if (!props.daySlots) {
            let dayOfWeek = format(date, 'EEEE').toLowerCase();
            return props.availability[dayOfWeek];
        }
        return props.daySlots;
    }

    const hasClasses = (classes, checkClasses) => {
        return (!(classes.filter(c => checkClasses.includes(c)).length === 0));
    }

    const classes = getClasses();

    return (
        <div className={`cell auto date-cell ${classes.join(' ')}`}>
            <div className="grid-x">
                <div className="cell small-8">
                    {format(day, 'd')}
                </div>
                <div className="cell small-4 text-right">
                    { !hasClasses(classes, ['past-date', 'diff-month']) &&
                        <OverridesAssistanceButton
                            daySlots={props.daySlots}
                            day={day}
                            availability={props.availability}
                            onChange={(slots) => props.onChange(dateIndex, slots)}
                        />
                    }
                </div>
            </div>

            { !hasClasses(classes, ['past-date', 'diff-month']) && (
                <TimeslotsInput
                    dateIndex={dateIndex}
                    slotValues={getDateOverrides(day)}
                    onChange={props.onChange}
                    message={(hasClasses(classes, ['is-closed'])) ? 'CLOSED TODAY' : null}
                />
            )}
        </div>
    );
}

CalendarOverridesDay.propTypes = {
    day: PropTypes.instanceOf(Date),
    daySlots: PropTypes.array,
    dayErrors: PropTypes.array,
    availability: PropTypes.object,
    currentDate: PropTypes.instanceOf(Date),
    onChange: PropTypes.func
}

export default CalendarOverridesDay;
